import { AuthFetchAPI } from '../../api/Auth';
import { ProductsFetchAPI } from '../../api/Paymentpost/Products';

// Mesas (Reservation.jsx) puede ser la primera pantalla tras el login cuando la maquina tiene
// startup_view = TABLES (ver resolveStartupRoute.jsx), sin pasar nunca por PaymentPost.jsx - que es
// quien normalmente puebla "generalData" (productos/grupos del menu) en localStorage la primera vez
// (ver getDataGeneralSmartpay en PaymentPost.jsx). Sin esto, los modales de Mesas que arman ordenes
// (RfmModals.jsx) no encuentran productos. Replica ese mismo fetch y la misma forma de dato; si ya
// hay data guardada para esta sucursal no la vuelve a pedir (PaymentPost sigue siendo quien la
// refresca cuando el contenido cambia, via getStatusContentMenu).
export const ensureGeneralData = async () => {
    try {
        const machine = JSON.parse(localStorage.getItem('machine') || 'null');
        const branchoffice = JSON.parse(localStorage.getItem('branchoffice') || 'null');
        const business = JSON.parse(localStorage.getItem('business') || 'null');
        const token = localStorage.getItem('x-access-machine-token');

        if (!machine?.id || !branchoffice?.id || !business?.id || !token) return;

        const raw = localStorage.getItem('generalData');
        let generalData = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(generalData)) generalData = [];

        const alreadyLoaded = generalData.some((entry) => entry.branchoffice_id == branchoffice.id);
        if (alreadyLoaded) return;

        const response_allgroups = await ProductsFetchAPI.getProductsByBranchOfficessByStatus(branchoffice.id, 1, token);
        const response = await AuthFetchAPI.getMenuGenerate(token, machine.id, branchoffice.id, business.id);

        generalData.push({
            branchoffice_id: branchoffice.id,
            data: response.data.data,
            groups_by_branchoffice: response_allgroups.data.data
        });

        localStorage.setItem('generalData', JSON.stringify(generalData));
    } catch (err) {
        // Silencioso a proposito: si falla, Mesas no debe bloquearse por esto - simplemente los
        // modales de productos quedaran vacios hasta que se reintente (siguiente entrada a POS o
        // recarga de Mesas, que vuelve a llamar a ensureGeneralData).
    }
}
